export const fileExtension = 'xls';
export const fileExtensionTemplate = 'xlsx';
export const acceptedExtensions = '.csv, .xls, .xlsx, .pdf';

export const FILE_FORMATS = ['pdf', 'xls'] as Utils.FileType[];